import React from 'react';

interface FlowOption {
  key: string;
  label: string;
  description?: string;
}

interface FlowSelectorCardProps {
  flows: FlowOption[];
  onSelectFlow: (flowKey: string) => void;
}

const FlowSelectorCard: React.FC<FlowSelectorCardProps> = ({ flows, onSelectFlow }) => {
  return (
    <div className="w-full flex flex-col gap-4 font-plus-jakarta">
      <div className="bg-blue-50 border-l-4 border-[#0B4BB6] p-4 mb-2">
        <p className="text-sm text-[#0B4BB6]">
          Please select the workflow you would like to proceed with.
        </p>
      </div>
      <div className="flex flex-col gap-3">
        {flows.map((flow) => (
          <div
            key={flow.key}
            className="border border-[#D7DFEC] rounded-lg p-5 cursor-pointer hover:border-[#0B4BB6] transition-colors bg-white flex flex-col gap-1"
            onClick={() => onSelectFlow(flow.key)}
          >
            <span className="text-[#141435] font-bold text-[16px]">{flow.label}</span>
            {flow.description && (
              <span className="text-[#485D7D] text-[13px]">{flow.description}</span>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default FlowSelectorCard;
